import React from 'react';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";
function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

class LinkPlus extends React.Component {
  static propTypes = {
    to: PropTypes.string.isRequired,
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    onClick: null,
  };

  handleClick = event => {
    if (this.props.onClick) {
      this.props.onClick(event);
    }

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
      return;
    }

    if (event.defaultPrevented === true) {
      return;
    }
    event.preventDefault();
  };

  render() {
    const { to, children, className, ...props } = this.props;
    return (
        <Link className={className||""} to={to} {...props}>
          {children}
        </Link>
      // <a href={to} {...props} className={className||""} onClick={this.handleClick}>
      //   {children}
      // </a>
  );
  }
}

export default LinkPlus;
